import type { AxiosRequestConfig } from 'axios';

import axios from 'axios';

import { CONFIG } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: CONFIG.site.serverUrl });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error && error.response && error.response.data) || new Error('Bir hata oluştu!')
    )
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  file: {
    upload: '/file/upload',
  },
  auth: {
    me: '/auth/me',
    signIn: '/auth/login',
    signUp: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  restaurant: {
    list: '/restaurants',
    create: '/restaurants',
    delete: (id: string) => `/restaurants/${id}`,
  },
  branch: {
    list: (restaurantId: string) => `/branches/${restaurantId}`,
    create: '/branches',
    update: '/branches',
    delete: (id: string) => `/branches/${id}`,
  },
  category: {
    list: (restaurantId: string) => `/categories/${restaurantId}`,
    create: `/categories`,
    update: `/categories`,
    updateMany: `/categories/multiple`,
    delete: (id: string) => `/categories/${id}`,
  },
  product: {
    list: (restaurantId: string) => `/products/${restaurantId}`,
    create: '/products',
    details: (productId: string) => `/products/${productId}`,
    update: '/products/',
    delete: (productId: string) => `/products/${productId}`,
    search: '/products/search',
  },
  extras: {
    list: (restaurantId: string) => `/extra-products/${restaurantId}`,
    create: '/extra-products',
    update: '/extra-products',
    delete: (extraId: string) => `/extra-products/${extraId}`,
  },
  report: {
    views: {
      hourly: (restaurantId: string) => `/reports/restaurant-views/${restaurantId}/hourly`,
      daily: (restaurantId: string) => `/reports/restaurant-views/${restaurantId}/daily`,
      monthly: (restaurantId: string, year?: number) =>
        `/reports/restaurant-views/${restaurantId}/monthly${year ? `/${year}` : ''}`,
    },
    categoryClicks: (restaurantId: string) => `/reports/category-clicks/${restaurantId}`,
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
};
